import Pessoa from "model/administracao/cadastro/Pessoa";
import { BaseModel } from "model/BaseModel";
import ItemEmprestimo from "./ItemEmprestimo";

export default class EmprestimoPatrimonio implements BaseModel {

    id: number;
    codigo: string | null;
    pessoaEmprestada: Pessoa | null;
    dataEmprestimo: Date | null;
    dataPrevistaDevolucao: Date | null;
    status: string;
    observacao: string;
    itens: ItemEmprestimo[];

    constructor(
        id = 0,
        codigo = null,
        pessoaEmprestada = null,
        dataEmprestimo = null,
        dataPrevistaDevolucao = null,
        status = "CRIADO",
        observacao = "",
        itens = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.pessoaEmprestada = pessoaEmprestada;
        this.dataEmprestimo = dataEmprestimo;
        this.dataPrevistaDevolucao = dataPrevistaDevolucao;
        this.status = status;
        this.observacao = observacao;
        this.itens = itens;
    }
}